import { render } from "./versionTariffication.vue?vue&type=template&id=892a7114"
import script from "./versionTariffication.vue?vue&type=script&lang=js"
export * from "./versionTariffication.vue?vue&type=script&lang=js"

import "./versionTariffication.vue?vue&type=style&index=0&id=892a7114&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__